import { KidAvatar, AdultAvatar } from "@/components/Avatars";

export const AMBER = "var(--st-amber)";
export const EMOJIS = ["🛒", "🏬", "🎯", "💊", "🔨", "🥦", "🍞", "🧀", "🍕", "🎂", "🎁", "🐶", "🧼", "🏕️", "🎒", "🍷"];
export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export function Who({ who, size = 22 }) {
  if (!who) return null;
  return who.kind === "kid" ? <KidAvatar avatar={who.avatar} size={size} /> : <AdultAvatar name={who.name || "?"} picture={who.picture} size={size} />;
}

export function Shoppers({ list, size = 26, testid }) {
  if (!list?.length) return null;
  return (
    <span className="flex -space-x-1.5" data-testid={testid}>
      {list.map((s) => <span key={s.key} title={`${s.name} is shopping`} className="rounded-full ring-2 ring-q-surface"><Who who={s} size={size} /></span>)}
    </span>
  );
}

export const shoppingLine = (shoppers, store) => {
  const names = shoppers.map((s) => s.name);
  const who = names.length > 1 ? `${names.slice(0, -1).join(", ")} and ${names.at(-1)} are` : `${names[0]} is`;
  return `${who} shopping${store ? ` at ${store}` : ""}`;
};
